<template>
  <div>
    <!-- 跟单备注提示 -->
    <el-dialog :title="$t('message.reminderForTrackingNotes')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center :show-close="false">
      <div class="content">
        <div class="table">
          <ol>
            <!-- 番号 -->
            <li class="flex05">{{ $t('message.mash') }}</li>
            <!-- 备注 -->
            <li>{{ $t('message.remark') }}</li>
          </ol>
          <ul v-for="(item, index) in remarkList" :key="index">
            <!-- 番号 -->
            <li class="flex05">{{ item.sorting }}</li>
            <!-- 备注 -->
            <li>{{ item.remark }}</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {

  data() {
    return {
      remarkList: [],
      dialogVisible: false,
      adminList: [],
      id: JSON.parse(localStorage.getItem('japanUserRoleInfo')).id
    };
  },
  created() {

  },

  methods: {
    // 查看是否有跟单备注
    lookPromptRemarks(data) {

      data.forEach(item => {
        item.order_detail_notes.forEach(notes => {

          let notesData = notes.read_log.find(log => log.admin_id == this.id && log.readed_at == '')
          if (notesData != undefined) {
            this.remarkList.push({
              sorting: item.sorting,
              remark: notes.remark,
              id: notes.id,
            })
          }

        })
      })
      if (this.remarkList != false) {
        this.dialogVisible = true
      }

    },
    // 保存
    save() {
      let datas = {
        ids: []
      }
      this.remarkList.forEach(item => {
        datas.ids.push(item.id)
      })
      this.$api.orderApi.markNotesReadedAt(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
      })


    },
  },

};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }


    }

    li {
      border-right: 1px solid #edeff4;
      padding: 10px 5px;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.35;
      text-align: center;
    }

    .flex15 {
      flex: 1.5;
    }

    .template {
      width: 100%;
      text-align: left;

      p {
        margin-bottom: 5px;

        &:nth-last-child(1) {
          margin: 0;
        }
      }
    }
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 100%;
  }

  /deep/.el-textarea__inner {
    min-height: 100px !important;
  }
}
</style>